var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39.64259 44.13677",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .a {\r\n        fill: #fff;\r\n      }\r\n\r\n      .b {\r\n        fill: #0f0e0b;\r\n      }\r\n\r\n      .c {\r\n        fill: #121210;\r\n      }\r\n\r\n      .d, .e, .f, .g, .h, .i, .j, .k, .l, .m, .n {\r\n        fill: none;\r\n        stroke: #121210;\r\n        stroke-linecap: round;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .d {\r\n        stroke-width: 0.70476px;\r\n      }\r\n\r\n      .e {\r\n        stroke-width: 0.65442px;\r\n      }\r\n\r\n      .f {\r\n        stroke-width: 0.59458px;\r\n      }\r\n\r\n      .g {\r\n        stroke-width: 0.50249px;\r\n      }\r\n\r\n      .h {\r\n        stroke-width: 0.44312px;\r\n      }\r\n\r\n      .i {\r\n        stroke-width: 0.40967px;\r\n      }\r\n\r\n      .j {\r\n        stroke-width: 0.56256px;\r\n      }\r\n\r\n      .k {\r\n        stroke-width: 0.52744px;\r\n      }\r\n\r\n      .l {\r\n        stroke-width: 0.46056px;\r\n      }\r\n\r\n      .m {\r\n        stroke-width: 0.38247px;\r\n      }\r\n\r\n      .n {\r\n        stroke-width: 0.69574px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M41.02056,13.88439c-.27154-2.54891-1.4497-5.39226-3.74483-5.5857a3.49015,3.49015,0,0,0-4.354,3.34351A2.95325,2.95325,0,0,0,33.96356,14.186a21.05206,21.05206,0,0,0,3.02551,2.347c1.14808.78782,2.35643,1.61768,3.53058,2.56873.58721.47982,1.1631.9863,1.71966,1.53554.55992.55954,1.04089,1.07442,1.58523,1.72545a15.8041,15.8041,0,0,1,3.38462,9.25789,17.22623,17.22623,0,0,1-2.38437,9.72,17.0255,17.0255,0,0,1-7.794,6.77194A24.94079,24.94079,0,0,1,27.309,50.01588l-.0799.00095-.2071-.02205a26.12556,26.12556,0,0,1-8.00451-1.79069,17.76891,17.76891,0,0,1-7.29077-5.41558A19.24216,19.24216,0,0,1,8.06387,34.4507,26.80351,26.80351,0,0,1,7.869,25.89338l.01358-.10126c.39471-2.94433,2.62682-5.51917,3.41489-4.7311,4.79456,4.79456,7.64217,3.21613,7.24747,6.16046a5.54414,5.54414,0,0,1-.1106.58061,16.61351,16.61351,0,0,0-.43252,5.13705,9.6838,9.6838,0,0,0,1.30706,4.3474,8.65158,8.65158,0,0,0,3.35384,3.03576,17.71761,17.71761,0,0,0,5.23268,1.72056l-.28661-.02107a17.56072,17.56072,0,0,0,6.79932-.575,10.25486,10.25486,0,0,0,5.12406-3.57223,11.30371,11.30371,0,0,0,2.18714-6.21576,10.79548,10.79548,0,0,0-1.61642-6.50254,26.34133,26.34133,0,0,0-5.43158-5.59066,23.55861,23.55861,0,0,1-3.2952-3.176,7.32466,7.32466,0,0,1-1.29262-2.37881,5.57852,5.57852,0,0,1-.22369-1.42582l-.00158-.71372.115-.66326a6.4384,6.4384,0,0,1,2.803-4.3623A6.04433,6.04433,0,0,1,37.789,6.21724,5.77726,5.77726,0,0,1,40.03379,7.4141,6.06848,6.06848,0,0,1,41.44656,9.425a11.03965,11.03965,0,0,1,.88093,4.4316.65274.65274,0,0,1-1.30145.07967Z",
    transform: "translate(-7.59049 -5.93862)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "6.202 21.239 5.762 19.96 4.875 20.981 6.202 21.239"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "31.837 6.177 35.702 5.542 34.696 10.359 31.837 6.177"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M35.92584,6.99717a5.20091,5.20091,0,0,1,1.55732.23863,5.54275,5.54275,0,0,1,1.08121.439,3.77427,3.77427,0,0,0-1.17178-.30861,5.20727,5.20727,0,0,0-.97625-.09351,4.50669,4.50669,0,0,0-2.82809.954,4.65412,4.65412,0,0,0-1.68855,3.38744A3.93084,3.93084,0,0,0,33.222,14.94291a21.62694,21.62694,0,0,0,3.17548,2.47321c1.1397.78206,2.3182,1.59075,3.46365,2.51855.61584.50322,1.15556.985,1.64553,1.46852.58546.58508,1.04152,1.08139,1.52153,1.65546a14.9149,14.9149,0,0,1,3.15657,8.673,15.79737,15.79737,0,0,1-9.57907,15.5226,23.70547,23.70547,0,0,1-9.33437,1.82024l-.02081.00025-.14841-.01581a25.09847,25.09847,0,0,1-7.73222-1.722,16.82964,16.82964,0,0,1-6.88357-5.10886,18.20791,18.20791,0,0,1-3.46484-7.90028,25.82259,25.82259,0,0,1-.18716-8.243l.01356-.10121c.31249-2.331,1.7819-4.42426,2.34332-4.42426.029,0,.151.05881.32563.32012A10.12352,10.12352,0,0,0,15.597,25.15515c1.64057.862,2.039,1.1864,1.931,1.99206a4.51988,4.51988,0,0,1-.09.47262,17.55376,17.55376,0,0,0-.45877,5.45755,10.65392,10.65392,0,0,0,1.44973,4.78774,9.60307,9.60307,0,0,0,3.69071,3.37156,18.26693,18.26693,0,0,0,5.37719,1.80672l-.00268.033c.72712.06484,1.44287.09772,2.12737.09772a16.84,16.84,0,0,0,5.07006-.7178,11.302,11.302,0,0,0,5.61268-3.92041,12.28418,12.28418,0,0,0,2.38814-6.77145,11.72125,11.72125,0,0,0-1.77883-7.09763A26.79228,26.79228,0,0,0,35.297,18.86557l-.38987-.333a19.95337,19.95337,0,0,1-2.78507-2.72027,6.3538,6.3538,0,0,1-1.0983-2.00558c-.01827-.08229-.03748-.16447-.0567-.2466a3.46272,3.46272,0,0,1-.13314-.91882l-.00139-.62659.10132-.58429A5.41444,5.41444,0,0,1,33.2938,7.74367a4.82265,4.82265,0,0,1,2.632-.7465m0-1a5.849,5.849,0,0,0-3.17547.907,6.43845,6.43845,0,0,0-2.803,4.3623l-.115.66325.00158.71373a5.57807,5.57807,0,0,0,.22368,1.42582,7.32452,7.32452,0,0,0,1.29263,2.3788,23.558,23.558,0,0,0,3.29519,3.176A26.34107,26.34107,0,0,1,40.077,25.21481a10.79547,10.79547,0,0,1,1.61643,6.50255,11.3038,11.3038,0,0,1-2.18714,6.21575,10.25486,10.25486,0,0,1-5.12406,3.57224,15.83074,15.83074,0,0,1-4.76079.66877c-.67194,0-1.35318-.03265-2.03854-.09377l.28662.02107a17.71738,17.71738,0,0,1-5.23269-1.72056A8.65149,8.65149,0,0,1,19.283,37.34509,9.68372,9.68372,0,0,1,17.976,32.9977a16.61318,16.61318,0,0,1,.43252-5.13705,5.54153,5.54153,0,0,0,.11059-.58061c.39471-2.94433-3.91627-2.58316-6.17089-5.95633a1.42335,1.42335,0,0,0-1.157-.76442c-1.45806,0-3.02534,2.98556-3.33445,5.29139l-.01357.10126a26.80351,26.80351,0,0,0,.19491,8.55732,19.24223,19.24223,0,0,0,3.66285,8.33781,17.76885,17.76885,0,0,0,7.29076,5.41557,26.12533,26.12533,0,0,0,8.00451,1.79069l.20711.02206.0799-.00095a24.94078,24.94078,0,0,0,9.72175-1.90334,17.02551,17.02551,0,0,0,7.794-6.77194,17.22632,17.22632,0,0,0,2.38438-9.72,15.80417,15.80417,0,0,0-3.38462-9.25789c-.54435-.651-1.02532-1.16591-1.58523-1.72545-.55656-.54924-1.13246-1.05573-1.71966-1.53554-1.17415-.95106-2.3825-1.78091-3.53059-2.56873a21.05068,21.05068,0,0,1-3.0255-2.347,2.9532,2.9532,0,0,1-1.04182-2.54382,3.68269,3.68269,0,0,1,1.31462-2.69131,3.49762,3.49762,0,0,1,2.20578-.7368,4.20478,4.20478,0,0,1,.83358.0846c2.29513.19343,3.4733,3.03679,3.74483,5.5857l.00549.05186a.65276.65276,0,0,0,.64859.58066l.00779,0a.65271.65271,0,0,0,.64506-.66028,11.03965,11.03965,0,0,0-.88093-4.4316A6.06845,6.06845,0,0,0,40.008,7.47266,5.77727,5.77727,0,0,0,37.76315,6.2758a6.12213,6.12213,0,0,0-1.83731-.27863Z",
    transform: "translate(-7.59049 -5.93862)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "31.913 6.231 35.777 5.596 34.771 10.413 31.913 6.231"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M12.11892,27.08394a1.86808,1.86808,0,1,1-3.65929-.754",
    transform: "translate(-7.59049 -5.93862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M15.76962,27.84163a1.86809,1.86809,0,0,1-3.6593-.754",
    transform: "translate(-7.59049 -5.93862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M17.2366,30.09787A1.86809,1.86809,0,0,1,15.784,27.89121",
    transform: "translate(-7.59049 -5.93862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M12.71768,35.91345a1.86808,1.86808,0,0,1-3.71008.44076",
    transform: "translate(-7.59049 -5.93862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M16.42076,35.47888a1.86809,1.86809,0,0,1-3.71009.44076",
    transform: "translate(-7.59049 -5.93862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M18.52547,37.156A1.8681,1.8681,0,0,1,16.45,35.52138",
    transform: "translate(-7.59049 -5.93862)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M17.896,44.651a1.73465,1.73465,0,0,1,.02788,2.453",
    transform: "translate(-7.59049 -5.93862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M20.31971,42.1787a1.73465,1.73465,0,0,1-2.42513,2.48089",
    transform: "translate(-7.59049 -5.93862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M23.17087,41.15474a1.25588,1.25588,0,0,1-.41073,1.04549,1.73465,1.73465,0,0,1-2.453.02789",
    transform: "translate(-7.59049 -5.93862)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M28.72117,48.22289a1.57645,1.57645,0,0,1,1.43947.98146",
    transform: "translate(-7.59049 -5.93862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M28.76677,45.07763a1.576,1.576,0,1,1-.0412,3.1518",
    transform: "translate(-7.59049 -5.93862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M30.12229,42.669A1.57624,1.57624,0,0,1,28.78946,45.118",
    transform: "translate(-7.59049 -5.93862)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M38.24035,45.47854a1.57648,1.57648,0,0,1,1.73163.19182",
    transform: "translate(-7.59049 -5.93862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M36.80567,42.67918a1.576,1.576,0,1,1,1.44163,2.80307",
    transform: "translate(-7.59049 -5.93862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M37.52538,40.58186a1.576,1.576,0,0,1-.68072,2.12236",
    transform: "translate(-7.59049 -5.93862)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M44.34154,38.36724a1.33192,1.33192,0,0,1,1.80936-.52366",
    transform: "translate(-7.59049 -5.93862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M42.01515,37.08087a1.33192,1.33192,0,1,1,2.333,1.2857",
    transform: "translate(-7.59049 -5.93862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M41.53063,35.27067A1.33192,1.33192,0,0,1,42.05429,37.08",
    transform: "translate(-7.59049 -5.93862)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M45.48044,30.49539a1.17456,1.17456,0,0,1,1.16738-1.1817",
    transform: "translate(-7.59049 -5.93862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M43.13617,30.50633a1.17456,1.17456,0,0,1,2.34908-.01432",
    transform: "translate(-7.59049 -5.93862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M41.98425,29.32147a1.17456,1.17456,0,0,1,1.1817,1.16738",
    transform: "translate(-7.59049 -5.93862)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M43.579,24.24171c-.27385-.53355-.21853-.92258.315-1.19642",
    transform: "translate(-7.59049 -5.93862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M41.64944,25.22861a1.0859,1.0859,0,1,1,1.93216-.99169",
    transform: "translate(-7.59049 -5.93862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M40.20479,24.73153a1.0859,1.0859,0,0,1,1.46193.47023",
    transform: "translate(-7.59049 -5.93862)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M41.42374,18.79",
    transform: "translate(-7.59049 -5.93862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M39.80648,20.23949a.86392.86392,0,0,1,.01762-1.33884",
    transform: "translate(-7.59049 -5.93862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M38.19048,21.68374a1.08589,1.08589,0,1,1,1.61726-1.44953",
    transform: "translate(-7.59049 -5.93862)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M34.26988,18.24855A1.0859,1.0859,0,0,1,35.88714,16.799",
    transform: "translate(-7.59049 -5.93862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M30.51362,13.7122a1.08589,1.08589,0,0,1,2.16937-.10243",
    transform: "translate(-7.59049 -5.93862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M31.53485,8.32514a1.0859,1.0859,0,1,1,1.66608,1.39315",
    transform: "translate(-7.59049 -5.93862)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M24.04871,45.9726a1.49116,1.49116,0,0,1-.936,2.83162",
    transform: "translate(-7.59049 -5.93862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M24.98684,43.14814a1.49116,1.49116,0,1,1-.936,2.83162",
    transform: "translate(-7.59049 -5.93862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M26.87962,42.24326a1.49116,1.49116,0,0,1-1.88383.94779",
    transform: "translate(-7.59049 -5.93862)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M33.83783,45.378a1.49116,1.49116,0,1,1,1.09378,2.7745",
    transform: "translate(-7.59049 -5.93862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M32.75025,42.60765a1.49116,1.49116,0,1,1,1.09378,2.7745",
    transform: "translate(-7.59049 -5.93862)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M40.95344,41.27256a1.39807,1.39807,0,0,1,1.85842,2.08918",
    transform: "translate(-7.59049 -5.93862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M39.10182,39.185a1.39807,1.39807,0,1,1,1.85842,2.08919",
    transform: "translate(-7.59049 -5.93862)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M44.28611,34.189a1.2208,1.2208,0,0,1,2.40044.44647",
    transform: "translate(-7.59049 -5.93862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M41.89126,33.74a1.2208,1.2208,0,0,1,2.40043.44646",
    transform: "translate(-7.59049 -5.93862)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M43.92086,27.41161a1.0138,1.0138,0,1,1,1.96765-.48941",
    transform: "translate(-7.59049 -5.93862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M41.95657,27.8972a1.01379,1.01379,0,0,1,1.96764-.4894",
    transform: "translate(-7.59049 -5.93862)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M41.016,22.72412a1.0138,1.0138,0,0,1,1.58643-1.2627",
    transform: "translate(-7.59049 -5.93862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M39.431,23.982a1.0138,1.0138,0,0,1,1.58642-1.2627",
    transform: "translate(-7.59049 -5.93862)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M38.50052,17.5235",
    transform: "translate(-7.59049 -5.93862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M37.0627,18.95312a1.01381,1.01381,0,0,1,.0041-1.43372",
    transform: "translate(-7.59049 -5.93862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M35.45543,19.12468a1.25494,1.25494,0,0,1,1.6082-.17654",
    transform: "translate(-7.59049 -5.93862)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M32.88073,15.48059a1.01379,1.01379,0,0,1,.0041-1.43372",
    transform: "translate(-7.59049 -5.93862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M31.44793,15.4715a1.0138,1.0138,0,0,1,1.43372.0041",
    transform: "translate(-7.59049 -5.93862)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M31.57447,11.06883a1.01379,1.01379,0,0,1,1.11057-.90675",
    transform: "translate(-7.59049 -5.93862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M30.67216,9.95581a1.01379,1.01379,0,0,1,.90675,1.11057",
    transform: "translate(-7.59049 -5.93862)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M13.55936,31.50026a1.86808,1.86808,0,1,0,3.70813.45687",
    transform: "translate(-7.59049 -5.93862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M9.8582,31.0496a1.86809,1.86809,0,1,0,3.70814.45688",
    transform: "translate(-7.59049 -5.93862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M8.36406,32.69111A1.86886,1.86886,0,0,0,9.82873,31.092",
    transform: "translate(-7.59049 -5.93862)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M16.19225,39.73921a1.84416,1.84416,0,1,0,3.50166-1.15851",
    transform: "translate(-7.59049 -5.93862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M12.69944,40.90032a1.84417,1.84417,0,0,0,3.50167-1.1585",
    transform: "translate(-7.59049 -5.93862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M12.3686,42.69667a1.84277,1.84277,0,0,0,.32244-1.74609",
    transform: "translate(-7.59049 -5.93862)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVp);
export default __webpack_public_path__ + "static/media/VP.5ad25b397f8d2efdd6b3a25f760af38a.svg";
export { ForwardRef as ReactComponent };